import { Component, inject } from '@angular/core';

import { AuthUserService } from '@services/auth-user.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent {
  authUserService = inject(AuthUserService);
}
